module.exports = __webpack_public_path__ + "img/jgt.c2671764.jpg";